// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2a9f0ada","879":"7897bb8d"}[chunkId] + ".chunk.js";
};